var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFeuillesW(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.99 36.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_358",
    "data-name": "Groupe 358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_189",
    "data-name": "Groupe 189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3908",
    "data-name": "Trac\\xE9 3908",
    d: "M12.47,36.11a.48.48,0,0,1-.51-.43V6.28a.48.48,0,0,1,.51-.42.47.47,0,0,1,.51.42v29.4a.47.47,0,0,1-.51.43",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_190",
    "data-name": "Groupe 190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3909",
    "data-name": "Trac\\xE9 3909",
    d: "M12.48,1.32c-1.7,2.28-2.38,4.35-2,6.18a5.26,5.26,0,0,0,2,3.17,5,5,0,0,0,2.13-3.41c.29-2.45-1.34-4.92-2.11-5.94m0,10.48a.52.52,0,0,1-.25-.07,6.25,6.25,0,0,1-2.78-4C9,5.42,9.9,2.9,12.07.19A.51.51,0,0,1,12.46,0a.49.49,0,0,1,.39.17C13,.31,16,3.76,15.6,7.38a6.11,6.11,0,0,1-2.84,4.33.52.52,0,0,1-.29.09",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_191",
    "data-name": "Groupe 191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3910",
    "data-name": "Trac\\xE9 3910",
    d: "M1.09,12.55c.49,3.56,1.72,6,3.66,7.38a6.64,6.64,0,0,0,4.71,1,6.29,6.29,0,0,0-1.15-5c-2-2.5-5.74-3.21-7.22-3.4m7.31,9.5a7.42,7.42,0,0,1-4.21-1.27C1.88,19.19.46,16.25,0,12a.56.56,0,0,1,.14-.41.5.5,0,0,1,.4-.16c.24,0,5.82.36,8.57,3.85a7.39,7.39,0,0,1,1.3,6.15.52.52,0,0,1-.37.4,6.5,6.5,0,0,1-1.64.18",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_192",
    "data-name": "Groupe 192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3911",
    "data-name": "Trac\\xE9 3911",
    d: "M12.47,24.41a.51.51,0,0,1-.36-.15.5.5,0,0,1,0-.71h0l7.73-7.73a.51.51,0,0,1,.72,0h0a.51.51,0,0,1,0,.72h0l-7.73,7.73a.48.48,0,0,1-.36.15",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_193",
    "data-name": "Groupe 193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3912",
    "data-name": "Trac\\xE9 3912",
    d: "M12,24.41a.48.48,0,0,0,.36-.15.5.5,0,0,0,0-.71h0L4.59,15.81a.51.51,0,0,0-.72,0h0a.51.51,0,0,0,0,.72h0l7.73,7.73a.51.51,0,0,0,.36.15",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_194",
    "data-name": "Groupe 194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3913",
    "data-name": "Trac\\xE9 3913",
    d: "M15.43,20.9a6.31,6.31,0,0,0,5-1.16c2.49-2,3.2-5.74,3.4-7.21-3.56.49-6,1.71-7.38,3.65a6.62,6.62,0,0,0-1,4.72M16.66,22a10.38,10.38,0,0,1-1.76-.16.52.52,0,0,1-.4-.37,7.63,7.63,0,0,1,1.1-5.86c1.59-2.31,4.53-3.72,8.74-4.18a.49.49,0,0,1,.41.14.49.49,0,0,1,.15.4c0,.23-.36,5.82-3.84,8.57A6.86,6.86,0,0,1,16.66,22",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_195",
    "data-name": "Groupe 195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3914",
    "data-name": "Trac\\xE9 3914",
    d: "M36.4,36.23a.6.6,0,0,1-.6-.6V13.42a2.11,2.11,0,0,0-.57-1.58,2.59,2.59,0,0,0-1.71-.58H15.35a.6.6,0,0,1-.6-.6h0a.6.6,0,0,1,.6-.6H33.47A3.78,3.78,0,0,1,36,11a3.27,3.27,0,0,1,1,2.46V35.63a.6.6,0,0,1-.6.6",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_196",
    "data-name": "Groupe 196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3915",
    "data-name": "Trac\\xE9 3915",
    d: "M32.7,18.79H24.91a.36.36,0,0,1-.36-.36h0a.37.37,0,0,1,.35-.36h7.8a.36.36,0,0,1,0,.72",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_197",
    "data-name": "Groupe 197"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3916",
    "data-name": "Trac\\xE9 3916",
    d: "M32.7,20.78H24.91a.36.36,0,0,1-.36-.36h0a.37.37,0,0,1,.35-.36h7.8a.36.36,0,0,1,0,.72",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_198",
    "data-name": "Groupe 198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3917",
    "data-name": "Trac\\xE9 3917",
    d: "M32.69,25.65H17.26a.36.36,0,0,1-.36-.36h0a.36.36,0,0,1,.36-.36H32.69a.36.36,0,0,1,.36.36h0a.36.36,0,0,1-.36.36h0",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_366",
    "data-name": "Groupe 366"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3917-2",
    "data-name": "Trac\\xE9 3917-2",
    d: "M32.69,29.73H17.26a.36.36,0,0,1-.36-.36h0a.36.36,0,0,1,.36-.36H32.69a.36.36,0,0,1,.36.36h0a.36.36,0,0,1-.36.36h0",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_368",
    "data-name": "Groupe 368"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3917-3",
    "data-name": "Trac\\xE9 3917-3",
    d: "M32.69,33H17.26a.36.36,0,0,1-.36-.36h0a.36.36,0,0,1,.36-.36H32.69a.36.36,0,0,1,.36.36h0a.36.36,0,0,1-.36.36h0",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_199",
    "data-name": "Groupe 199"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3918",
    "data-name": "Trac\\xE9 3918",
    d: "M32.69,28.1H17.26a.36.36,0,0,1-.36-.36h0a.36.36,0,0,1,.36-.36H32.69a.36.36,0,0,1,.36.36h0a.36.36,0,0,1-.36.36h0",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_365",
    "data-name": "Groupe 365"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3918-2",
    "data-name": "Trac\\xE9 3918-2",
    d: "M32.69,31.36H17.26A.36.36,0,0,1,16.9,31h0a.36.36,0,0,1,.36-.36H32.69a.36.36,0,0,1,.36.36h0a.36.36,0,0,1-.36.36h0",
    style: {
      fill: "#fff"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFeuillesW);
export default __webpack_public_path__ + "static/media/ic-feuilles-w.fcdb689a3f02762387c5e255360875e4.svg";
export { ForwardRef as ReactComponent };